import { RouteProp } from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { AHButton, AHSeparator, Box, useLayoutContext } from "arkh";
import React, { useCallback, useState } from "react";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { graphql, useMutation } from "react-relay";
import { useIntlTokens } from "../../../components/mobile/useIntlTokens";
import { KPIEditParamList, KPIUnit } from "./KPIEditParamList";
import { KPIUnitSelector } from "../components/KPIUnitSelector";
import { KPIEditUnitMutation } from "./__generated__/KPIEditUnitMutation.graphql";

type Props = {
  navigation: NativeStackNavigationProp<KPIEditParamList, "KPIEditUnit">;
  route: RouteProp<KPIEditParamList, "KPIEditUnit">;
};

export function KPIEditUnit(props: Props) {
  const insets = useSafeAreaInsets();
  const layout = useLayoutContext();
  const [unit, setUnit] = useState<KPIUnit>(props.route.params.unit);
  const intl_tokens = useIntlTokens();

  const [saveKPIUnit, loading] = useMutation<KPIEditUnitMutation>(graphql`
    mutation KPIEditUnitMutation(
      $routineId: ID!
      $updateTasks: [UpdateRoutineUpdateTaskInput!]!
    ) {
      routine(id: $routineId) {
        update(input: { updateTasks: $updateTasks }) {
          routine {
            id
            activeVersion {
              tasks {
                id
                ... on TaskNumber {
                  unit
                }
              }
            }
          }
        }
      }
    }
  `);

  const onSave = useCallback(() => {
    saveKPIUnit({
      variables: {
        routineId: props.route.params.routineId,
        updateTasks: [
          {
            taskId: props.route.params.taskId,
            number: {
              setUnit: unit,
            },
          },
        ],
      },
      onCompleted: props.navigation.goBack,
    });
  }, [
    props.navigation,
    props.route.params.routineId,
    props.route.params.taskId,
    saveKPIUnit,
    unit,
  ]);

  return (
    <Box style={{ flex: 1 }}>
      <Box space="medium">
        <KPIUnitSelector setUnit={setUnit} unit={unit} />
      </Box>
      <Box style={{ flex: 1 }} />
      <AHSeparator />
      <Box
        style={{
          paddingBottom:
            Math.max(layout.space.large, insets.bottom) + layout.space.medium,
        }}
        spaceHorizontal="medium"
        spaceTop="medium"
      >
        <AHButton
          themeType="primary"
          onPress={onSave}
          title={intl_tokens.Save}
          loading={loading}
        />
      </Box>
    </Box>
  );
}
